import { type } from '../utils/assist'

export default {
    data() {
        return {
            config: {}, // 配置对象
            configExclude: [], // 非配置项prop
            configWatchers: [], // 自定义watch
            interface: [], // 接口集合
        }
    },
    watch: {
        configExclude: {
            handler(val) {
                this.configWatchers.forEach(unwatch => unwatch())
                this.configWatchers.splice(
                    0,
                    this.configWatchers.length,
                    this._watchProps()
                )
            },
        },
    },
    created() {
        this.configWatchers.push(this._watchProps())
    },
    beforeDestroy() {
        // 移除config
        this.config = void 0
        this.configWatchers = []
        // 接口解绑
        this._detachInterface()
    },
    methods: {
        // 收集prop依赖
        _iterateProps(cb) {
            Object.keys(this.$props).forEach(k => {
                // 排除非配置字段
                if (this.configExclude == 'all') {
                    return true
                }

                if (this.configExclude.indexOf(k) < 0) {
                    var v = this.$props[k]

                    if (cb) {
                        cb.call(this, v, k, this.$props)
                    }
                }
            })
        },
        // 根据prop动态修改config
        _watchProps() {
            // prop更新次数
            var updateCount = 0

            return this.$watch(
                function() {
                    this._iterateProps()

                    return updateCount++
                },
                function() {
                    this._iterateProps((v, k) => {
                        if (type(v) == 'undefined') {
                            this.$delete(this.config, k)
                        } else {
                            this.$set(this.config, k, v)
                        }
                    })
                },
                {
                    immediate: true,
                }
            )
        },
        // 事件委托
        _attachEvents(proxy) {
            Object.keys(this.$listeners).forEach(name =>
                proxy.on(name, this.$listeners[name])
            )
        },
        // 移除委托
        _detachEvents(proxy) {
            Object.keys(this.$listeners).forEach(name =>
                proxy.off(name, this.$listeners[name])
            )
        },
        // 接口委托
        _attachInterface(proxy) {
            this.interface.forEach(k =>
                Object.defineProperty(this, k, {
                    configurable: true,
                    get() {
                        return proxy[k]
                    },
                })
            )
        },
        // 移除方法委托
        _detachInterface() {
            this.interface.forEach(k => {
                delete this[k]
            })
        },
    },
}
